
import PostalInput from '../components/PostalInput'
import ValidAreas from '../components/ValidAreas'
import InvalidPostal from '../components/InvalidPostal'
import StoreStatus from '../components/StoreStatus'

import { get } from 'vuex-pathify'

export default {
  components: {
    PostalInput,
    ValidAreas,
    InvalidPostal,
    StoreStatus
  },
  computed: {
    valid: get('delivery/validPostalCode'),
    postal: get('delivery/postalCode'),
    canCheckout: get('delivery/canCheckout')
  },
  methods: {
    onCheckout() {
      if (this.$route.path == this.$pagePath('checkout')) {
        this.$drawer.close('shopping-cart')
      } else {
        this.$navigateTo('checkout')
      }
    }
  }
}
